import { render, staticRenderFns } from "./InfoForSysops.vue?vue&type=template&id=5d60e4d5&scoped=true&"
import script from "./InfoForSysops.vue?vue&type=script&lang=js&"
export * from "./InfoForSysops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60e4d5",
  null
  
)

export default component.exports